import { useMemo, useSyncExternalStore } from 'react';
import { Clip } from '@/domains/asset';
import { doesClipHaveThumbnail } from '@/libs/clipUtils';
import { FeatureFlagKeys } from '@/services/featureFlag';
import featureFlagStore from '@/stores/featureFlagStore';

export const useRemotionThumbnail = ({ clip }: { clip: Clip }) => {
  const featureFlags = useSyncExternalStore(featureFlagStore.subscribe, featureFlagStore.getSnapshot);
  const canUseRemotionThumbnail = useMemo(() => {
    return featureFlags[FeatureFlagKeys.Use_CL_Remotion_Thumbnail] && doesClipHaveThumbnail(clip);
  }, [featureFlags, clip]);

  return { canUseRemotionThumbnail };
};
